(function(){
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='1';
    var btn=root.querySelector('[data-smb-add]'),total=root.querySelector('[data-smb-total]'),err=root.querySelector('[data-smb-err]');
    root.querySelectorAll('.smb__mode input').forEach(function(r){r.addEventListener('change',function(){if(!total)return;var t=(r.type==='checkbox'&&!r.checked)?r.dataset.totalOff:r.dataset.total;if(t)total.textContent=t;});});
    var syncs=[].slice.call(root.querySelectorAll('[data-smb-item][data-smb-sync]'));
    if(syncs.length){
      var setV=function(id){
        if(!id)return;id=String(id);
        syncs.forEach(function(li){
          var map;try{map=JSON.parse(li.dataset.smbSync);}catch(e){return;}
          if(!map[id])return;
          var inp=li.querySelector('[data-smb-variant]'),vt=li.querySelector('[data-smb-vt]');
          if(inp)inp.value=id;if(vt)vt.textContent=map[id].t;
        });
      };
      var mainId=function(){
        var f=[].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function(x){return !x.closest('[data-smb]');})[0];
        var i=f&&f.querySelector('[name="id"]');return i&&i.value;
      };
      document.addEventListener('variant:change',function(e){var v=e.detail&&(e.detail.variant||e.detail);setV(v&&v.id);});
      document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('[data-smb]'))return;[60,400,1000].forEach(function(t){setTimeout(function(){setV(mainId()||new URLSearchParams(location.search).get('variant'));},t);});});
      setV(new URLSearchParams(location.search).get('variant')||mainId());
    }
    if(!btn)return;
    btn.addEventListener('click',function(){
      var mode=root.querySelector('.smb__mode input:checked');var sub=mode&&mode.value==='sub';
      var items=[];
      root.querySelectorAll('[data-smb-item]').forEach(function(li){
        var v=li.querySelector('[data-smb-variant]');if(!v||!v.value)return;
        var it={id:+v.value,quantity:1};if(sub&&li.dataset.plan)it.selling_plan=+li.dataset.plan;items.push(it);
      });
      if(!items.length)return;
      btn.disabled=true;btn.classList.add('is-busy');if(err)err.hidden=true;
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
        .then(function(){var d=document.querySelector('cart-drawer');if(d&&typeof d.show==='function'&&window.themeVariables&&themeVariables.settings&&themeVariables.settings.cartType==='drawer'){document.dispatchEvent(new CustomEvent('cart:refresh'));d.show();btn.disabled=false;btn.classList.remove('is-busy');}else{window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';}})
        .catch(function(e){btn.disabled=false;btn.classList.remove('is-busy');if(err){err.textContent=(e&&(e.description||e.message))||'Something went wrong. Please try again.';err.hidden=false;}});
    });
  }
  function run(){document.querySelectorAll('[data-smb]').forEach(init);}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();
